import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "mv-header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mv-header-info" }
const _hoisted_4 = { class: "mv-header-name" }
const _hoisted_5 = { class: "mv-header-role" }
const _hoisted_6 = {
  key: 0,
  class: "mv-stale-bar"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "mv-search-wrap" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "mv-section-label" }
const _hoisted_11 = { class: "mv-section-count" }
const _hoisted_12 = { class: "mv-period" }
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = {
  key: 1,
  class: "mv-loading"
}
const _hoisted_15 = {
  key: 2,
  class: "mv-empty"
}
const _hoisted_16 = {
  key: 3,
  class: "mv-list"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "mv-item-av-wrap" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "mv-item-body" }
const _hoisted_22 = { class: "mv-item-r1" }
const _hoisted_23 = { class: "mv-item-name" }
const _hoisted_24 = { class: "mv-item-time" }
const _hoisted_25 = { class: "mv-item-r2" }
const _hoisted_26 = {
  key: 0,
  class: "mv-unread"
}
const _hoisted_27 = {
  key: 0,
  class: "mv-item-tags"
}
const _hoisted_28 = {
  key: 0,
  class: "mv-tag mv-tag-snoozed"
}
const _hoisted_29 = {
  key: 1,
  class: "mv-tag mv-tag-team"
}
const _hoisted_30 = { class: "mv-footer-bar" }
const _hoisted_31 = ["disabled"]

import type { Conversation } from '@/types/dashboard'
import { avatarColor, initials } from '@/composables/useHelpers'
import { dotClass, convTime } from '@/utils/mobileFormat'
import type { VisaoGeralPeriodo } from '@/composables/useDashboardEngine'


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileConvList',
  props: {
    authUser: {},
    dataStale: { type: Boolean },
    loading: { type: Boolean },
    hasConversations: { type: Boolean },
    countdown: {},
    query: {},
    filteredConvs: {},
    logoUrl: {},
    previewText: { type: Function },
    periodo: {}
  },
  emits: ["update:query", "update:periodo", "logout", "refresh", "open-chat"],
  setup(__props: any) {





// Mesmas duas opções/labels do toggle "Visão Geral" do desktop (KpiGrid.vue)
// — período aqui filtra a própria lista de conversas do mobile, não só um
// KPI, mas o rótulo/comportamento (Esta semana/Mês) é o mesmo em espírito.
const periodOptions: { value: VisaoGeralPeriodo; label: string }[] = [
  { value: 'week',  label: 'Semana' },
  { value: 'month', label: 'Mês' },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("img", {
        src: __props.logoUrl,
        class: "mv-logo",
        alt: "ISBET"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.authUser?.name), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.authUser?.role === 'administrator' ? 'Administrador' : 'Agente'), 1)
      ]),
      _createElementVNode("button", {
        class: "mv-icon-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('logout'))),
        title: "Sair"
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("svg", {
          width: "18",
          height: "18",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
          _createElementVNode("polyline", { points: "16 17 21 12 16 7" }),
          _createElementVNode("line", {
            x1: "21",
            y1: "12",
            x2: "9",
            y2: "12"
          })
        ], -1)
      ]))])
    ]),
    (__props.dataStale)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
            _createElementVNode("line", {
              x1: "12",
              y1: "9",
              x2: "12",
              y2: "13"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "17",
              x2: "12.01",
              y2: "17"
            })
          ], -1)),
          _cache[8] || (_cache[8] = _createTextVNode(" Sem conexão — dados desatualizados ", -1)),
          _createElementVNode("button", {
            class: "mv-stale-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refresh'))),
            disabled: __props.loading
          }, "Tentar", 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _cache[9] || (_cache[9] = _createElementVNode("svg", {
        class: "mv-search-ico",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, [
        _createElementVNode("circle", {
          cx: "11",
          cy: "11",
          r: "8"
        }),
        _createElementVNode("line", {
          x1: "21",
          y1: "21",
          x2: "16.65",
          y2: "16.65"
        })
      ], -1)),
      _createElementVNode("input", {
        value: __props.query,
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:query', ($event.target as HTMLInputElement).value))),
        class: "mv-search",
        type: "search",
        placeholder: "Buscar conversa…"
      }, null, 40, _hoisted_9)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[10] || (_cache[10] = _createElementVNode("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, [
        _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
      ], -1)),
      _cache[11] || (_cache[11] = _createTextVNode(" Minhas conversas ativas ", -1)),
      _createElementVNode("span", _hoisted_11, _toDisplayString(__props.filteredConvs.length), 1),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(periodOptions, (opt) => {
          return _createElementVNode("button", {
            key: opt.value,
            type: "button",
            class: _normalizeClass(["mv-period-btn", { active: __props.periodo === opt.value }]),
            disabled: __props.loading,
            onClick: ($event: any) => (_ctx.$emit('update:periodo', opt.value))
          }, _toDisplayString(opt.label), 11, _hoisted_13)
        }), 64))
      ])
    ]),
    (__props.loading && !__props.hasConversations)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[12] || (_cache[12] = [
          _createElementVNode("div", { class: "mv-spinner" }, null, -1),
          _createElementVNode("span", null, "Carregando conversas…", -1)
        ]))]))
      : (!__props.filteredConvs.length && !__props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _cache[13] || (_cache[13] = _createElementVNode("svg", {
              width: "52",
              height: "52",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
            ], -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", null, "Nenhuma conversa aberta atribuída a você", -1)),
            _createElementVNode("button", {
              class: "mv-refresh-btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('refresh')))
            }, "Atualizar")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filteredConvs, (conv) => {
              return (_openBlock(), _createElementBlock("div", {
                key: conv.id,
                class: _normalizeClass(["mv-item", { 'has-unread': conv.unread_count > 0 }]),
                onClick: ($event: any) => (_ctx.$emit('open-chat', conv))
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", {
                    class: "mv-item-av",
                    style: _normalizeStyle({ background: _unref(avatarColor)(conv.contact.name) })
                  }, [
                    (conv.contact.thumbnail)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: conv.contact.thumbnail,
                          alt: conv.contact.name,
                          onError: _cache[4] || (_cache[4] = (e) => (e.target as HTMLImageElement).style.display='none')
                        }, null, 40, _hoisted_19))
                      : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(initials)(conv.contact.name)), 1))
                  ], 4),
                  _createElementVNode("span", {
                    class: _normalizeClass(["mv-status-dot", _unref(dotClass)(conv)])
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(conv.contact.name), 1),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(convTime)(conv)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["mv-item-preview", { bold: conv.unread_count > 0 }])
                    }, _toDisplayString(__props.previewText(conv.id)), 3),
                    (conv.unread_count)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(conv.unread_count > 9 ? '9+' : conv.unread_count), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (conv.team || conv.labels.length || conv.status === 'snoozed')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        (conv.status === 'snoozed')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Adiada"))
                          : _createCommentVNode("", true),
                        (conv.team)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(conv.team.name), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conv.labels.slice(0, 2), (l) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: l,
                            class: "mv-tag"
                          }, _toDisplayString(l.replace(/_/g, ' ')), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("svg", {
                  class: "mv-item-chevron",
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
                ], -1))
              ], 10, _hoisted_17))
            }), 128))
          ])),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("span", null, "Atualiza em " + _toDisplayString(__props.countdown) + "s", 1),
      _createElementVNode("button", {
        class: "mv-refresh-sm",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('refresh'))),
        disabled: __props.loading
      }, [
        (_openBlock(), _createElementBlock("svg", {
          width: "13",
          height: "13",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: _normalizeClass({ 'spin': __props.loading })
        }, [...(_cache[16] || (_cache[16] = [
          _createElementVNode("polyline", { points: "23 4 23 10 17 10" }, null, -1),
          _createElementVNode("path", { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10" }, null, -1)
        ]))], 2)),
        _cache[17] || (_cache[17] = _createTextVNode(" Atualizar ", -1))
      ], 8, _hoisted_31)
    ])
  ], 64))
}
}

})